import { Component, OnInit, AfterViewInit } from "@angular/core";

import { Observable, Subscription, timer } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/takeWhile";

import { AutenticazioneService } from "@services/autenticazione.service";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";

// MAPPER
import { MapperBaseResponse } from "@mapper/mapper-baseresponse";
import { MapperSettore } from "@mapper/mapper-settore";
import { MapperProfilo } from "@mapper/mapper-profilo";
import { MapperUtente } from "@mapper/mapper-utente";
import { MapperAutorizzazione } from "@mapper/mapper-autorizzazione";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { MapperInfoCertificato } from "@app/shared/mapper/edocumento/mapper-info-certificato";
import { MapperInfoFirma } from "@app/shared/mapper/edocumento/mapper-info-firma";
import { MapperControlloFirma } from "@app/shared/mapper/edocumento/mapper-controllo-firma";
import { ProfiliService } from "@app/shared/services/profili.service";
import { MapperUtenteOperatore } from "@app/shared/mapper/mapper-utente-operatore";
import { MapperUfficio } from "@app/shared/mapper/mapper-ufficio";
import { MapperTokenAutenticazione } from "./shared/mapper/mapper-token-autenticazione";
import { CleanStringPipe } from "./utility/pipes/string-pipe";
import { EventiService } from "./shared/services/eventi.service";

import { StatoApplicazioneStore } from "./shared/store/stato-applicazione.store";
import { StatoApplicazioneVO } from "./shared/vo/stato-applicazioneVO";
import { DocumentaleDeeplinkVO } from "./shared/vo/documentale-deeplinkVO";
import { AppUtilityHelper } from "./shared/helper/app-utility.helper";
import { UrlUtils } from "./shared/common/url";
import { KeycloakService } from "keycloak-angular";
import { StatoApplicazioneService } from "./shared/services/stato-applicazione.service";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "body",
  template: "<router-outlet></router-outlet>",
  providers: [
    SlimLoadingBarService,
    AutenticazioneService,
    ProfiliService,
    MapperUtente,
    MapperProfilo,
    MapperSettore,
    MapperAutorizzazione,
    MapperInfoCertificato,
    MapperInfoFirma,
    MapperControlloFirma,
    MapperBaseResponse,
    MapperUtenteOperatore,
    MapperUfficio,
    MapperTokenAutenticazione,
    CleanStringPipe,
  ],
})
export class AppComponent implements AfterViewInit, OnInit {
  private statoApplicazione: StatoApplicazioneVO;
  private statoAppSubscription: Subscription;

  constructor(
    private slimLoader: SlimLoadingBarService,
    private router: Router,
    private autenticazioneService: AutenticazioneService,
    private eventiService: EventiService,
    private statoApplicazioneStore: StatoApplicazioneStore,
    appUtilityHelper: AppUtilityHelper,
    private keycloakService: KeycloakService
  ) {
    if (
      window.location.hash.length > 2 &&
      window.location.hash !== "#/pages/login" &&
      window.location.hash !== "#/pages/manutenzione"
    ) {
      let documentaleDeeplink: DocumentaleDeeplinkVO = new DocumentaleDeeplinkVO();
      console.log(
        "[login] url session app comp: ",
        window.location.hash.substring(1)
      );

      if (window.location.hash.includes("?")) {
        console.log(
          "[login] url session app comp params: ",
          window.location.hash.substring(window.location.hash.indexOf("?") + 1)
        );
        documentaleDeeplink.url = window.location.hash.substring(
          1,
          window.location.hash.indexOf("?")
        );

        documentaleDeeplink.params = appUtilityHelper.calcolaParamentriUrl(
          window.location.hash.substring(window.location.hash.indexOf("?") + 1)
        );
      } else {
        documentaleDeeplink.url = window.location.hash.substring(1);
      }
      console.log("[login] url session: ", documentaleDeeplink);
      sessionStorage.setItem(
        "documentale-deeplink",
        JSON.stringify(documentaleDeeplink)
      );
    }
    if (
      UrlUtils.queryParam("login") !== sessionStorage.getItem("loginParam") &&
      !sessionStorage.getItem("utente") &&
      UrlUtils.queryParam("state") !== sessionStorage.getItem("nonce")
    ) {
      console.log("[oauthService] navigate to /// LOGIN ////");
      this.router.navigate(["/pages/login/"]);
      return;
    }

    sessionStorage.removeItem("loginParam");
    if (sessionStorage.getItem("documentale-deeplink")) {
      let documentaleDeeplink: DocumentaleDeeplinkVO = JSON.parse(
        sessionStorage.getItem("documentale-deeplink")
      ) as DocumentaleDeeplinkVO;
      // authConfig.redirectUri = window.location.protocol + "//" + window.location.host + window.location.pathname + documentaleDeeplink.url;
      // sessionStorage.removeItem("linneo-deeplink");
    }

    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.slimLoader.start();
          // this.autenticazioneService.autentica();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.slimLoader.complete();
        }
      },
      () => {
        this.slimLoader.complete();
      }
    );
  }

  async ngOnInit() {
    const keycloakAuth = this.keycloakService.getKeycloakInstance();
    if (await this.keycloakService.isLoggedIn()) {
      this.autenticazioneService.autenticaByJWT(
        keycloakAuth.token,
        keycloakAuth.refreshToken
      );
      this.statoApplicazioneStore.avvia();
      // this.statoApplicazioneStore.setOnce();
      this.statoAppSubscription = this.statoApplicazioneStore
        .getStato()
        .subscribe((stato) => {
          this.elaboraStatoApp(stato);
        });

      keycloakAuth.onAuthError = (error) => {
        console.log("[AppComponent.onAuthError] keyclaok error: ", error);
      };
      keycloakAuth.onAuthRefreshError = () => {
        console.log("[AppComponent.onAuthRefreshError] .... ");
        keycloakAuth.logout();
      };
      keycloakAuth.onAuthRefreshSuccess = () => {
        console.log("[AppComponent.onAuthRefreshSuccess] .... ");
        this.autenticazioneService.autenticaByJWT(
          this.keycloakService.getKeycloakInstance().token,
          this.keycloakService.getKeycloakInstance().refreshToken
        );
      };
      keycloakAuth.onTokenExpired = () => {
        console.log("[AppComponent.onTokenExpired] token expired");
        if (keycloakAuth.refreshToken) {
          console.log(
            "[AppComponent] keycloakAuth.refreshToken ",
            keycloakAuth.refreshToken
          );
          keycloakAuth.updateToken(60).then(
            (success) => {
              if (success) {
                console.log("[AppComponent.updateToken] nuovo token");
                this.autenticazioneService.autenticaByJWT(
                  this.keycloakService.getKeycloakInstance().token,
                  this.keycloakService.getKeycloakInstance().refreshToken
                );
              } else {
                console.log("[AppComponent.updateToken] success false");
              }
            },
            (error) => {
              console.log(
                `[AppComponent.updateToken] errore on updateToken : ${error}`
              );
              keycloakAuth.logout();
            }
          );
        } else {
          keycloakAuth.logout();
        }
      };
    } else {
      console.log("[AppComponent.ngOnInit] is not logged!");

      try {
        console.log("[AppComponent.ngOnInit] call getToken");
        const mytoken = await this.keycloakService.getToken();
        console.log("[AppComponent.ngOnInit] getToken:", mytoken);
      } catch (ex) {
        console.log("[AppComponent.ngOnInit] errore invocazione getToken:", ex);
      }

      console.log("[AppComponent.ngOnInit] call this.keycloakService.login");
      // this.router.navigate(["/associa/"]);
      this.keycloakService.login({
        scope: "openid profile",
        redirectUri: window.location.protocol + "//" + window.location.host + window.location.pathname
      });
    }

  }

  private elaboraStatoApp(stato: StatoApplicazioneVO) {
    if (stato && stato.manutenzione && stato.manutenzione == true) {
      this.router.navigate(["/pages/manutenzione/"]);
    }
    if (
      this.statoApplicazione &&
      this.statoApplicazione.manutenzione &&
      stato &&
      !stato.manutenzione
    ) {
      this.router.navigate(["/"]).then((_) => window.location.reload());
    }
    this.statoApplicazione = stato;
  }

  ngAfterViewInit() {
    // this.autenticazioneService.autentica();
  }
}
